export default "__VITE_ASSET__BEjjYOpp__"